$(document).ready(function () {
  window.changeJobAdderStyle = function () {
    try {
      function selectChange() {
        $(this).parents('.ja-field-container').find("label").removeClass('selected');
        if ($(this).prop('selectedIndex') !== 0) {
          $(this).parents('.ja-field-container').find("label").addClass('selected');
        }
        if ($(this).prop('id') === 'ja-def-24066' && $('#ja-def-24067') !== null
          && $('#ja-def-24067').parents('.ja-field-container') !== null) {
          $('#ja-def-24067').parents('.ja-field-container').find("label").removeClass('selected');
        }
      }

      function textbxFocus() {
        $(this).parents('.ja-field-container').find("label").addClass('selected');
      }

      function textbxBlur() {
        if ($.trim($(this).val()) === '')
          $(this).parents('.ja-field-container').find("label").removeClass('selected');
      }

      function joblinkClick() {
        try {
          $("#ja-jobs-widget").off('click', '.back-link', backlinkClick).on('click', '.back-link', backlinkClick);
          $('div.ja-job-list div.job .title a').off('click', joblinkClick)
          $('.richtext').each(function () {
            $(this).hide()
            return;
          });
        } catch (e) {
          console.log('error in change JobAdder Style function.')
        }
      }

      function backlinkClick() {
        try {
          $("#ja-jobs-widget").off('click', '.back-link', backlinkClick)
          $('.richtext').each(function () {
            $(this).show()
            return;
          });
        } catch (e) {
          console.log('error in change JobAdder Style function.')
        }
      }

      function removeDuplicates(selector) {
        if ($(selector).length > 1) {
          $(selector).each(function (index) {
            if (index !== 0) {
              $(this).remove();
            };
          });
        };
      }

      $('div.ja-field select').each(function () {
        var op = $(this).find('option')[0];
        if (op !== null) {
          $(op).text('')
        }
        $(this).off('change', selectChange).on('change', selectChange);
      })

      if (window.location.href.indexOf("ja-job=") > -1) {
        $("#ja-jobs-widget").off('click', '.back-link', backlinkClick).on('click', '.back-link', backlinkClick);
        $('.richtext').each(function () {
          $(this).hide()
          return;
        });
      } else {
        $('.richtext').each(function () {
          $(this).show()
          return;
        });
      }

      $('div.ja-job-list div.job .title a').each(function () {
        $(this).prop("href", "?ja-job=" + $(this).attr('data-job-id'))
      })

      $('div.ja-job-list div.job a.view-details').each(function () {
        $(this).prop("href", "?ja-job=" + $(this).attr('data-job-id'))
      })

      removeDuplicates('.ja-job-search');
      removeDuplicates('.ja-job-list-container');
      removeDuplicates('.powered-by-jobadder');

      $('div.ja-field input').off('focus', textbxFocus).on('focus', textbxFocus);
      $('div.ja-field input').off('blur', textbxBlur).on('blur', textbxBlur);
      $('div.job .title a').off('click', joblinkClick).on('click', joblinkClick);
      // if ($('div.ja-pager a.next') !== null) $('div.ja-pager a.next').html('');
      // if ($('div.ja-pager a.previous') !== null) $('div.ja-pager a.previous').html('');
      /*
      $(document).ajaxComplete(function () {
        window.changeJobAdderStyle();
      });
      */

    } catch (e) {
      console.log('error in change JobAdder Style function.')
    }
  }

  window.refreshIntervalId = null;
  window.updateJobAdderAfterClick = false;

  window.addIntervalWatcher = function () {
    window.refreshIntervalId = setInterval(function () {

      if (window.enableJobAdderStyleChanges == true && $("#ja-jobs-widget div:first-child").length > 0) {
        window.changeJobAdderStyle();
        window.enableJobAdderStyleChanges = false;
        $("#ja-jobs-widget").on("click", function () {
          window.updateJobAdderAfterClick = true;
          window.addIntervalWatcher();
        });
      } else if (window.updateJobAdderAfterClick == true && $("#ja-jobs-widget .ja-job-search").length > 0) {
        window.changeJobAdderStyle();
        window.updateJobAdderAfterClick = false;
      } else if (window.enableJobAdderStyleChanges == false && window.updateJobAdderAfterClick == false) {
        clearInterval(window.refreshIntervalId);
      }
    }, 500);
  }
  window.addIntervalWatcher();
});
